/**
 * Where to go once signed in, when a page sent someone to sign in first (/auth/desktop does). Kept
 * for this tab only, used once, and only ever a path inside this app.
 */

import { safeNext } from './safeNext'

const KEY = 'devpulse.afterSignIn'

export function rememberAfterSignIn(path: string): void {
  try {
    sessionStorage.setItem(KEY, path)
  } catch {
    // Without storage the person lands on the start page, and can open the link again.
  }
}

/** The path to go to now, or the start page. Read twice, it answers the same; forget it once used. */
export function peekAfterSignIn(): string {
  try {
    return safeNext(sessionStorage.getItem(KEY))
  } catch {
    return safeNext(null)
  }
}

export function forgetAfterSignIn(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing kept, nothing to forget.
  }
}
